import { EmptyData, NavMenuError } from 'shared/ui';
import { SectionMenu } from 'shared/ui/section-menu';
import { COMPANY_ROUTES } from 'shared/consts/routes/company';

import { SECTION } from 'entities/navigation';
import { useGetCompaniesQuery } from 'entities/company';
import { AddButton } from './add-button';

const { label, path } = SECTION['companies'];

export function ConnectedCompaniesMenu() {
  const { data, isFetching, error } = useGetCompaniesQuery();

  if (data && data.statusCode !== 0) {
    return <NavMenuError text={data.statusDescription} />;
  }

  if (error) {
    return <NavMenuError />;
  }

  if (!isFetching && !data) {
    return <EmptyData />;
  }

  const items = data?.companies || [];

  return (
    <SectionMenu
      loading={isFetching}
      items={items}
      menuKey={path}
      absolutePath={COMPANY_ROUTES.COMPANIES}
      label={label}
      addButton={<AddButton />}
    />
  );
}
